import { Options, Splide } from '@splidejs/splide'

import { getElementChild, getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class ContactPersonList {
  private slider: null | Splide = null
  private readonly sliderElement: HTMLElement | null

  constructor(container: HTMLElement) {
    this.sliderElement = getElementChild(container, 'contact-person-slider')
  }

  public init(): void {
    this.initSlider()
  }

  private getSliderOptions(): Options {
    return {
      arrows: true,
      /* eslint-disable perfectionist/sort-objects -- splide requires descending breakpoint order */
      breakpoints: {
        1024: {
          perMove: 1,
          perPage: 3,
        },
        768: {
          pagination: false,
          perMove: 1,
          perPage: 2,
        },
        575: {
          focus: 'center',
          gap: '1rem',
          pagination: false,
          perMove: 1,
          perPage: 1.1,
        },
      },
      /* eslint-enable perfectionist/sort-objects */
      gap: '1.25rem',
      perMove: 1,
      perPage: 6,
      type: 'slide',
    }
  }

  private initSlider(): void {
    if (this.sliderElement === null) {
      return
    }

    const sliderOptions = this.getSliderOptions()
    this.slider = new Splide(this.sliderElement, sliderOptions)
    this.slider.on('resized', (): void => this.updateControlsVisibility())
    this.slider.mount()
    this.updateControlsVisibility()
  }

  private updateControlsVisibility(): void {
    if (this.slider === null || this.sliderElement === null) {
      return
    }

    const controls = this.sliderElement.querySelector<HTMLElement>('.splide__controls')

    if (controls === null) {
      return
    }

    const perPage = Math.ceil(this.slider.options.perPage ?? 6)
    controls.style.display = this.slider.length <= perPage ? 'none' : ''
  }
}

const containers = getElements('contact-person-list')

containers.forEach((container: HTMLElement): void => {
  const contactPersonList = new ContactPersonList(container)
  contactPersonList.init()
})
